import { ProductType } from '@inter-ikea-storageone/range';
import { ProductListConfig } from 'rangeConfig/@types';
import addProduct from 'rangeConfig/bror/behaviors/addProduct';

const wallOrganizersProductListConfig: ProductListConfig = {
  cluster: [],
  cardsTitle: 'name',
  cardsSubtitle: 'typeName, designText',
  behaviors: {
    productClicked: [addProduct],
    productDropped: [addProduct]
  },
  infoButtonAriaLabel: 'storageone.storageBoxes',
  mobileCardText: 'communicatedSizeText',
  sortOrder: [],
  categories: [
    {
      id: 'wall-organizers',
      products: [{ path: 'type', value: ProductType.SAMLA_ORGANIZER }]
    },
    {
      id: 'wall-organizers',
      products: [{ path: 'type', value: ProductType.SOCKERBIT_ORGANIZER }]
    },
    {
      id: 'wall-organizers',
      products: [{ path: 'type', value: ProductType.KUGGIS_ORGANIZER }]
    },
    {
      id: 'wall-organizers',
      products: [{ path: 'type', value: ProductType.KNAGGLIG_ORGANIZER }]
    }
  ],
  productFilters: []
};

export default wallOrganizersProductListConfig;
